import { useState } from "react";
import { Tooltip } from "reactstrap";

const PreFilterBadge = ({ label, value, index, field, callback = () => {} }) => {
  const [tooltipPreFilter, setTooltipPreFilter] = useState(false);

  const id = `${String(field?.replaceAll(" ", "_")).toLocaleLowerCase()}`
  
  if(label && label === "Data_Inicial") label = "De: "
  if(label && label === "Data_Final") label = "Até: "

  return (
    <>
      <button
        id={id}
        key={index}
        style={{ height: 30 }}
        onClick={() => callback(index)}
        className="badge-filter-applied-dynamic btn btn-light-blue-08 text-color-azul1 font-size-12 px-2 font-w-400 rounded-pill d-flex align-items-center gap-3"
      >
        {label}
        {value?.length > 20 ? value.substring(0, 20) + "..." : value}
        <i className="fas fa-times font-white"></i>
      </button>
      <Tooltip
        placement="top"
        className="tooltip-pre-filter"
        isOpen={tooltipPreFilter}
        target={id}
        toggle={() => {
          setTooltipPreFilter(!tooltipPreFilter);
        }}
      >
        {`${field} - ${value}`}
      </Tooltip>
    </>
  );
};

export default PreFilterBadge;
